export const isRequiredFunc = (field: string) => `${field} is required`;

export const isUrlFunc = (field: string) => `${field} should be valid url`;

export const isEmailFunc = (field: string) => `${field} should be valid email`;

export const isMinFunc = (field: string, numberOfCharacter: number) =>
  `${field} should be more than ${numberOfCharacter} characters`;

export const isMaxFunc = (field: string, numberOfCharacter: number) =>
  `${field} should not be greater than ${numberOfCharacter} characters`;

export const urlRegMatch =
  // eslint-disable-next-line max-len
  /^((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w\?[a-zA-Z-_%\/@?]+)*([^\/\w\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/;

export const passwordRegMatch =
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/gm;

export const isPasswordRegFunc = (field: string) =>
  `${field} must contain 8 characters, one uppercase letter, special character and number`;

export const isNumberFunc = (field: string) => `${field} must be a number`;
